// [DEV MN]
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if(document.body.classList.contains('template-product')){
        var sizeActive = this.closest('.product__info-container').querySelector('.variant-radios');

        let getProductID = parseInt($(this).closest('#coloumn-2').attr('data-product-id'));
        let getProductVarID = parseInt($(this).closest('#coloumn-2').attr('data-prod-var-id'));
        let getProductQTY = '1';
          // parseInt($('#product_quantity').val());
        let getProductPrice = parseInt($(this).closest('#coloumn-2').attr('data-prod-price'));
        let getProductDiscountPrice = parseInt($(this).closest('#coloumn-2').attr('data-prod-disc-price'));
        let getProductTotalQTY = parseInt($(this).closest('#coloumn-2').attr('data-product-total-qty'));
        
        // console.log('product', getProductID, getProductVarID, getProductPrice, getProductDiscountPrice, getProductQTY);
        
        dengage('ec:addToCart', {
          product_id: getProductID,
          product_variant_id: getProductVarID,
          quantity: getProductQTY,
          unit_price: getProductDiscountPrice,
          discounted_price: getProductPrice,
          stock_count: getProductTotalQTY,
        });
        
        if(sizeActive.classList.contains('active')){
          document.querySelector('#error-size').style.display = 'none'
          this.addToCart()
        }else{
          document.querySelector('#error-size').style.display = 'block'
          return
        }
      }else{
        this.addToCart()
      }
    }

    addToCart(){
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            if(document.body.classList.contains('template-product')){
              cartPopupUpdate()
              setTimeout(()=> {
                  body.classList.add('cart-popup-active')
                  body.classList.add('dropdown-shadow')
              },500)
            }
            // window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      // this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      // if (!this.errorMessageWrapper) return;
      // this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      // if (errorMessage) {
      //   this.errorMessage.textContent = errorMessage;
      // }
      if (errorMessage){
        body.classList.add('cart-error-active')
        document.querySelector('#cart-error-popup').innerText = errorMessage
        setTimeout(()=> {
          body.classList.remove('cart-error-active')
        },3000)
      }
    }
  });
}
